/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type CreateHardwareSkuMutationVariables = Types.Exact<{
  code: Types.Scalars["String"];
  name: Types.Scalars["String"];
  description: Types.Scalars["String"];
  image: Types.Scalars["String"];
  location: Types.Scalars["String"];
  category_id: Types.Scalars["Float"];
  type: Types.HardwareSkuType;
}>;

export type CreateHardwareSkuMutation = {
  createHardwareSku: Pick<
    Types.HardwareSku,
    | "code"
    | "name"
    | "description"
    | "image"
    | "location"
    | "category_id"
    | "type"
  >;
};

export const CreateHardwareSkuDocument = gql`
  mutation CreateHardwareSku(
    $code: String!
    $name: String!
    $description: String!
    $image: String!
    $location: String!
    $category_id: Float!
    $type: HardwareSkuType!
  ) {
    createHardwareSku(
      code: $code
      name: $name
      description: $description
      image: $image
      location: $location
      category_id: $category_id
      type: $type
    ) {
      code
      name
      description
      image
      location
      category_id
      type
    }
  }
`;

/**
 * __useCreateHardwareSkuMutation__
 *
 * To run a mutation, you first call `useCreateHardwareSkuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHardwareSkuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHardwareSkuMutation, { data, loading, error }] = useCreateHardwareSkuMutation({
 *   variables: {
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      location: // value for 'location'
 *      category_id: // value for 'category_id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateHardwareSkuMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateHardwareSkuMutation,
    CreateHardwareSkuMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateHardwareSkuMutation,
    CreateHardwareSkuMutationVariables
  >(CreateHardwareSkuDocument, baseOptions);
}
export type CreateHardwareSkuMutationHookResult = ReturnType<
  typeof useCreateHardwareSkuMutation
>;
export type CreateHardwareSkuMutationResult =
  ApolloReactCommon.MutationResult<CreateHardwareSkuMutation>;
export type CreateHardwareSkuMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateHardwareSkuMutation,
    CreateHardwareSkuMutationVariables
  >;
